import { accountActions } from './accountActions';
import { categorySourceActions } from './categorySourceActions';
import { appConfigAction } from './common/appConfigAction';
import { commonActions } from './commonActions';
import { dictionaryActions } from './dictionaryAction';
import { notifyActions } from './notify/notifyAction';
import { uploadActions } from './upload-file/uploadActions';
import { foCaAnActions } from './thuc-don/foCaAnAction';
import { foCaAnTruongActions } from './thuc-don/foCaAnTruongAction';
import { foMonAnChiTietActions } from './thuc-don/foMonAnChiTietAction';
import { foThucDonActions } from './thuc-don/foThucDonAction';
import { foDotDangKyAnActions } from './thuc-don/foDotDangKyAnActions';
import { foDangKyAnHocSinhActions } from './thuc-don/foDangKyAnHocSinhActions';
import { foDotDangKyPhamViActions } from './thuc-don/foDotDangKyPhamViActions';
import { hocSinhViewShortActions } from './thuc-don/hocSinhViewShortActions';
import { danhMucActionsWrapper } from './danh-muc/danhMucActionsWrapper';

export const actions = {
    account: accountActions,
    appConfig: appConfigAction,
    categorySource: categorySourceActions,
    common: commonActions,
    dictionary: dictionaryActions,
    uploadFile: uploadActions,
    notify: notifyActions,
    thucDonWrapper: {
        caAn: foCaAnActions,
        caAnTruong: foCaAnTruongActions,
        monAnChiTiet: foMonAnChiTietActions,
        thucDon: foThucDonActions,
        dotDangKyAn: foDotDangKyAnActions,
        dangKyAnHocSinh: foDangKyAnHocSinhActions,
        dotDangKyPhamVi: foDotDangKyPhamViActions,
        hocSinhViewShort: hocSinhViewShortActions
    },
    danhMucWrapper: danhMucActionsWrapper,
}

